module.exports = __webpack_public_path__ + "b698d842b4b57f12c820635c597a7496.png";